<template>
    <div>
        <app-sub-title text="Filtros" />
        <div class="d-flex align-items-end">
            <div class="px-1">
                <app-form-select-input
                    label="Tipo" 
                    :options="types"
                    v-model="filters.type"
                />
            </div>
            <div class="px-1">
                <app-form-text-input 
                    label="Destino"
                    v-model="filters.destination"
                />
            </div>
            <div class="px-1">
                <app-form-text-input 
                    label="Para"
                    v-model="filters.owner"
                />
            </div>
            <div class="px-1">
                <b-button variant="primary" @click="onFilter"><i class="fa fa-filter"></i></b-button>
            </div>
            <div class="px-1">
                <b-button variant="secondary" @click="cleanFilter"><i class="fa fa-times-circle"></i></b-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        types: {
            required: true,
            type: Array
        }
    },
    data(){
        return {
            filters: {
                type: '',
                destination: '',
                owner: ''
            }
        }
    },

    methods:{
        onFilter(){
            this.$emit('filter', this.filters);
        },
        cleanFilter(){
            Object.keys(this.filters).map(key => (this.filters[key] = ''));
            this.$emit('clean', this.filters);
        }
    },

    created(){
        this.$bus.$on('filters.clean', this.cleanFilter);  
    }
}
</script>
